/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cannotpublishevent2Inputs */

const en_cannotpublishevent2 = /** @type {(inputs: Cannotpublishevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot publish event`)
};

const de_cannotpublishevent2 = /** @type {(inputs: Cannotpublishevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event kann nicht veröffentlicht werden`)
};

/**
* | output |
* | --- |
* | "Cannot publish event" |
*
* @param {Cannotpublishevent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cannotpublishevent2 = /** @type {((inputs?: Cannotpublishevent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cannotpublishevent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cannotpublishevent2(inputs)
	return de_cannotpublishevent2(inputs)
});
export { cannotpublishevent2 as "cannotPublishEvent" }